"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSportId = exports.getSportName = void 0;
const activities_enums_1 = require("./activities.enums");
const SPORTS_MAP = Object.fromEntries(Object.entries(activities_enums_1.SportsEnum).map(([key, id]) => [id, activities_enums_1.SportNameEnum[key]]));
const SPORT_NAME_TO_ID = Object.fromEntries(Object.entries(SPORTS_MAP).map(([id, name]) => [name, +id]));
const getSportName = (sportId) => SPORTS_MAP[sportId];
exports.getSportName = getSportName;
const getSportId = (sportName) => SPORT_NAME_TO_ID[sportName];
exports.getSportId = getSportId;
//# sourceMappingURL=activities.consts.js.map